import { render, staticRenderFns } from "./customize-tree.vue?vue&type=template&id=1927bc60&"
import script from "./customize-tree.vue?vue&type=script&lang=js&"
export * from "./customize-tree.vue?vue&type=script&lang=js&"
import style0 from "./customize-tree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports